var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWcIntrectiveMessageImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 191,
    viewBox: "0 0 306 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18095_870)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.984,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.834 -0.296875C89.7483 -0.296875 111.662 -0.296875 133.576 -0.296875C139.282 1.3165 143.963 4.504 147.621 9.26562C149.149 11.922 150.345 14.7111 151.207 17.6328C151.606 43.332 151.606 69.0312 151.207 94.7305C149.161 103.451 143.881 109.228 135.369 112.062C134.871 101.51 134.572 90.9509 134.473 80.3867C131.51 64.2757 122.047 54.4143 106.084 50.8027C85.8509 49.5064 73.0013 58.5708 67.5352 77.9961C66.9333 89.3438 66.4355 100.699 66.041 112.062C57.4312 108.732 52.1519 102.556 50.2031 93.5352C49.8047 68.8322 49.8047 44.1289 50.2031 19.4258C52.2101 9.35241 58.0871 2.77821 67.834 -0.296875Z",
    fill: "#6A097D"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.987,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.986 -0.296875C203.701 -0.296875 225.416 -0.296875 247.131 -0.296875C256.222 2.11944 262.099 7.89681 264.762 17.0352C265.435 30.0656 265.734 43.1144 265.658 56.1816C265.734 69.2488 265.435 82.2974 264.762 95.3281C261.75 105.711 254.876 111.588 244.143 112.959C224.42 113.358 204.697 113.358 184.975 112.959C174.502 111.652 167.629 105.974 164.355 95.9258C163.379 70.6443 163.18 45.3437 163.758 20.0234C165.576 9.34404 171.652 2.57061 181.986 -0.296875Z",
    fill: "#1F384C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.99,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.952 305.707C157.085 305.707 123.218 305.707 89.3504 305.707C75.7041 291.182 65.0461 274.647 57.3758 256.102C51.6943 234.071 46.3154 211.958 41.2391 189.762C37.8499 175.821 43.3284 168.849 57.6746 168.844C65.4423 169.189 70.7214 172.974 73.5125 180.199C76.8994 194.742 80.2857 209.285 83.6726 223.828C83.8717 176.414 84.0713 129 84.2703 81.5859C86.3448 72.7717 91.9233 67.9905 101.005 67.2422C109.446 67.9175 114.825 72.3002 117.141 80.3906C117.34 100.113 117.54 119.836 117.739 139.559C121.323 130.843 127.798 127.157 137.163 128.502C146.169 131.145 150.651 137.222 150.61 146.73C154.353 137.834 161.027 134.149 170.632 135.674C179.874 138.76 184.158 145.235 183.481 155.098C188.297 144.675 196.165 141.388 207.089 145.236C211.761 147.519 214.65 151.205 215.755 156.293C216.153 181.395 216.153 206.496 215.755 231.598C213.742 258.455 205.474 283.158 190.952 305.707Z",
    fill: "#1F384C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18095_870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 306,
    height: 306,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcIntrectiveMessageImg);
export default __webpack_public_path__ + "static/media/wc-intrective-message-img.18b3a121f8cdfc2411c9ffd4cf9f2676.svg";
export { ForwardRef as ReactComponent };